<template>
  <div class="froala-editor"></div>
</template>

<script>

import _ from 'underscore'
import './plugins/clex.js' // Load CLEX Froala plugin

/**
 * Helper function to determine if element is of type tagName,
 * or has an ancestor of type tagName
 */

const isWithinTag = (tagName, elem) => {
  return $(elem).closest(tagName).length > 0;
}

export default {
  name: 'froala-editor',

  data() {
    return {
      html: '',
    }
  },

  props: {
    chapterId: Number, // Used when creating an image micro note
    // content: String, // not sure what this is for. https://github.com/surmon-china/vue-quill-editor/blob/master/editor.vue
    value: String,
    imageCreatedFunction: Function,
    config: {
      type: Object,
      required: false,
      default() {
        return {}
      }
    }
  },

  mounted() {
    this.initialize();
  },

  beforeDestroy() {
    if(this.froalaEditor) this.froalaEditor.froalaEditor('destroy')
    this.froalaEditor = null
  },

  methods: {
    initialize() {
      const self = this;
      const config = Object.assign({key: 'nddlrE4ol=='}, self.config || {});

      self.froalaEditor = $(this.$el).froalaEditor(config).eq(0);

      // Set editor content
      self.froalaEditor.froalaEditor('html.set', self.value)





      // Example of how to bind custom events to click event
      // self.froalaEditor.on('froalaEditor.click', function (e, editor, clickEvent) {
      //   console.log(clickEvent.target) --> hr.divider
      //   // Do something here.
      // });






      // Pretty hacky but it works!
      // #todo - bind ready event and possibly move this code to the ready event if it causes troubles in other pages
      $('.fr-box').css('height', '100%');
      $('body').css('height', '100%');

      // Mark model as touched if editor lost focus??
      // self.froalaEditor.on('froalaEditor.blur', function (e, editor) {
      // // Do something here.
      // });

      // update model if text changes
      self.froalaEditor.on('froalaEditor.contentChanged', (e, editor) => {
        const html = editor.html.get()
        self.html = html
        // console.log('content changed')
        self.$emit('input', html)
        self.$emit('change', {
          editor: self.froalaEditor,
          html: html,
        })
      })


      /**
       * Listen for clex.convertImageToMicroNote
       */

      self.froalaEditor.on('froalaEditor.clex.convertImageToMicroNote', (e, editor) => {
        if( !self.chapterId) throw new Error('froalaEditor.clex.convertImageToMicroNote - Missing required param chapterId')
        // console.log('froalaEditor.clex.convertImageToMicroNote')
        // console.log(self.chapterId);
        const imageUrl = editor.image.get().attr('src');
        const height = editor.image.get().attr('height');
        const width = editor.image.get().attr('width');

        // Create the new micro note
        this.$store.dispatch('createMicroNote', {
          microNote: {
            image_url: imageUrl,
            image_height: height,
            image_width: width,
            // lecture_note_id: 1,
            chapter_id: self.chapterId,
            micro_note_type: 'image',
          },
          callback(err) {
            if (!err) {
              if (self.imageCreatedFunction) {
                self.imageCreatedFunction();
              }
              // Remove the image and show the success message
              editor.image.remove();
              Toast.success('Image converted to Micro Note. Keywords can be identified in the next step, once "create micro notes" is selected above.')
            } else {
              Toast.error('Failed to convert image to Micro Note')
            }
          },
        })
      })


      /**
       * Child tags within a <keyword> will cause problems. We don't want
       * user to be able to do anything to a keyword other than change the text.
       */

      // Only these commands are allowed in the context of a keyword
      const keywordAllowedCommands = [
        'undo',
        'redo',
        'CLEX_Keyword',
        'html',
      ];
      self.froalaEditor.on('froalaEditor.commands.before', (e, editor, cmd) => {
        // See if it's allowed
        const isAllowed = _.contains(keywordAllowedCommands, cmd);
        if(isAllowed) return true;

        // See if we're acting on a keyword
        const startElem = editor.selection.element();
        const endElem = editor.selection.endElement();
        const isWithinKeyword = isWithinTag('keyword', startElem) || isWithinTag('keyword', endElem);
        if(isWithinKeyword) {
          console.log(`${cmd} is blocked within a keyword`)
          return false;
        }
      });


      self.$emit('ready')
    },

  },


  watch: {
  //   html(newVal, oldVal) {
  //     console.log('html changed')
  //     if(newVal !== this.html) {
  //       this.html = newVal
  //       this.froalaEditor.froalaEditor('html.set', newVal)
  //     } else if( !newVal) {
  //       this.froalaEditor.froalaEditor('html.set', '')
  //     }
  //   },

    // So for a component to work with v-model, it must: accept a value prop
    value(newVal, oldVal) {
      if( !this.froalaEditor) return;

      if(newVal !== this.html) {
        this.html = newVal;
        this.froalaEditor.froalaEditor('html.set', newVal)
      }
      // if (this.quillEditor) {
      //   if (newVal !== this._content) {
      //     this._content = newVal
      //     this.quillEditor.pasteHTML(newVal)
      //   } else if(!newVal) {
      //     this.quillEditor.setText('')
      //   }
      // }
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  [is='divider'] {
    display: block;
    height: 5px;
    background: #4285f4;
    margin: 10px 0;
  }

</style>



// WEBPACK FOOTER //
// FroalaEditor.vue?c5f644e2